export default __webpack_public_path__ + "static/media/AG18.16d0d2e4.mp3";